import { useEffect, useState } from "react";

import { LOCAL_BASE_URL } from "../constants/constants";
import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";
import { logger } from "../utils/logger";

const useFaq = () => {
	const [faqData, setFaqData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchFaqData = async () => {
			try {
				const response = await axiosRequestInterceptor.get(`/faq/getFAQs`);
				logger.log("response", response);
				if (response.data.success) {
					setFaqData(response.data.data);
				} else {
					throw new Error("Failed to fetch FAQ data");
				}
			} catch (err) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchFaqData();
	}, []);

	return { faqData, loading, error };
};

export default useFaq;
